import { render, staticRenderFns } from "./Archives01.vue?vue&type=template&id=b1beb654&scoped=true"
import script from "./Archives01.vue?vue&type=script&lang=js"
export * from "./Archives01.vue?vue&type=script&lang=js"
import style0 from "./Archives01.vue?vue&type=style&index=0&id=b1beb654&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b1beb654",
  null
  
)

export default component.exports